import { Component, OnInit } from '@angular/core';
import { MenuStore } from 'app/menus/service/menu.store';
import { Constants } from 'app/shared/constants';
import { MatchingPropertyService } from 'app/shared/matching-property/matching-property.service';
import { Page } from 'app/shared/models/page';
import { Observable } from 'rxjs/Observable';
import { MatchingProperty } from '../models/matching-property';
import { PagesizeType } from '../service/pagination/pagesize-type';

@Component({
  selector: 'pioneer-matching-property',
  templateUrl: './matching-property.component.html'
})
export class MatchingPropertyComponent implements OnInit {

  pagesizeType = PagesizeType.MATCHING_PROPERTY;

  currentPage: number;

  constructor(
    private matchingPropertyService: MatchingPropertyService,
    private menuStore: MenuStore) {
  }

  ngOnInit() {
    this.menuStore.setPageHeader('EVENT.PROPERTY_REVIEW.LIST_PAGE_TITLE', false);
    this.currentPage = Constants.SEARCH_DEFAULT_PAGE;
  }

  get propertiesPresent(): Observable<boolean> {
    return this.propertyCount.map(propertyCount => {
      return propertyCount > 0;
    });
  }

  get propertyCount(): Observable<number> {
    return this.matchingPropertyService.totalPropertyCount;
  }

  get propertyCountForTranslate(): Object {
    return {
      propertyCount: this.propertyCount
    };
  }

  onRefreshList(page?: number) {
    this.currentPage = page;
    this.matchingPropertyService
      .refreshMatchingProperties(page)
      .take(1).subscribe();
  }

  get properties(): Observable<Page<MatchingProperty>> {
    return this.matchingPropertyService.properties;
  }

  sortList(field: string, direction: string) {
    this.matchingPropertyService.setCurrentField(field);
    this.matchingPropertyService.setCurrentDirection(direction);
    this.onRefreshList(this.currentPage);
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/matching-property/matching-property.component.ts